import { render, staticRenderFns } from "./auth_scope_form.vue?vue&type=template&id=0fc9693e"
import script from "./auth_scope_form.vue?vue&type=script&lang=js"
export * from "./auth_scope_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports